import { BANKING_PARTNERS } from "@/data/company";

export default function BankingPartners({ dark = false }) {
  // Duplicate list for seamless marquee
  const items = [...BANKING_PARTNERS, ...BANKING_PARTNERS];

  return (
    <section
      data-testid="banking-partners"
      className={`py-16 lg:py-20 ${dark ? "bg-slate-950" : "bg-white"} border-y ${
        dark ? "border-slate-900" : "border-slate-200"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 mb-12">
          <div>
            <div className="overline text-slate-500">
              Offshore Banking Associations
            </div>
            <h3
              className={`mt-3 font-serif text-2xl lg:text-3xl tracking-tight ${
                dark ? "text-white" : "text-slate-900"
              }`}
            >
              Anchored by institutional banking relationships.
            </h3>
          </div>
          <p
            className={`max-w-md text-sm leading-relaxed ${
              dark ? "text-slate-400" : "text-slate-500"
            }`}
          >
            Treasury, custody, and cross-border settlement supported by
            tier-one global banking partners.
          </p>
        </div>

        <div className="overflow-hidden relative">
          <div className="marquee-track flex items-center gap-16 lg:gap-20 whitespace-nowrap py-2">
            {items.map((p, i) => (
              <div
                key={`${p.name}-${i}`}
                data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}-${i}`}
                className="flex-none h-14 lg:h-16 flex items-center justify-center group"
                title={p.name}
              >
                <img
                  src={p.logo}
                  alt={p.name}
                  className={`max-h-12 lg:max-h-14 w-auto object-contain transition-all duration-300 ${
                    dark
                      ? "brightness-0 invert opacity-60 group-hover:opacity-100"
                      : "grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100"
                  }`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          {/* edge fades */}
          <div
            className={`pointer-events-none absolute inset-y-0 left-0 w-20 ${
              dark
                ? "bg-gradient-to-r from-slate-950 to-transparent"
                : "bg-gradient-to-r from-white to-transparent"
            }`}
          />
          <div
            className={`pointer-events-none absolute inset-y-0 right-0 w-20 ${
              dark
                ? "bg-gradient-to-l from-slate-950 to-transparent"
                : "bg-gradient-to-l from-white to-transparent"
            }`}
          />
        </div>
      </div>
    </section>
  );
}
